import { render, staticRenderFns } from "./BillingCard.vue?vue&type=template&id=48cb44ff&"
import script from "./BillingCard.vue?vue&type=script&lang=js&"
export * from "./BillingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports